import styled from 'styled-components';
import { coloredThreewayCheckboxStyle } from '../../dashboard/Meta/styles';

export const Container = styled.div`
    background-color: ${p => p.theme.c.pale};
    padding: 16px 0;
    ${coloredThreewayCheckboxStyle}
`;